import { Box, Divider, Grid, Group, Paper, Stack, Text } from '@mantine/core';
import { sumBy } from 'lodash';

import { UTBReportDataDeclaration, UTBReportDataGroup } from '@e-origin/shared';

import { UTB_REPORT_DECIMAL_PLACES } from '@constants';

interface UTBResourcesProps {
  group: UTBReportDataGroup;
  declaration: UTBReportDataDeclaration;
  t: (path: string, variables?: Record<string, any>) => string;
}

export const UTBResources = ({ group, declaration, t }: UTBResourcesProps) => {
  return (
    <Paper withBorder mb="xs">
      <Group p="xs" justify="space-between" align="flex-start">
        <Text fw={700}>{t('RESOURCES.DECLARATION_NUMBER', { movementReference: group.movementReference || '' })}</Text>
        <Text>{t('RESOURCES.SEQUENCE', { sequence: declaration.sequence })}</Text>
      </Group>
      <Divider />
      <Stack p="xs" gap="xs">
        <Group justify="space-between">
          <Text>{t('RESOURCES.COMMODITY_CODE.HS_CODE', { hsCode: declaration.commodityCode.hsCode })}</Text>
          <Text>{t('RESOURCES.REFERENCE_NUMBER_UCR', { ucr: declaration.consignment.referenceNumberUCR })}</Text>
        </Group>
        <Group justify="space-between">
          <Text>{t('RESOURCES.COMMODITY_CODE.INVOICE_DESCRIPTION', { invoiceDescription: declaration.commodityCode.invoiceDescription })}</Text>
          <Text>{t('RESOURCES.SHIPPING_MARKS', { shippingMarks: declaration.shippingMarks })}</Text>
        </Group>
      </Stack>
      {declaration.calculationResultsItems.map((item, idx) => (
        <div key={idx}>
          <Divider />
          <Box p="xs">
            <Text fw={700}>
              {t('RESOURCES.RESOURCE', { taxType: item.taxType })} {t(item.taxType === 'B00' ? 'RESOURCES.VAT' : 'RESOURCES.IMPORT_DUTIES')}
            </Text>
          </Box>

          <Box p="xs">
            <Text>{t('RESOURCES.TAXABLE_AMOUNT', { amount: (item.amount || 0).toFixed(UTB_REPORT_DECIMAL_PLACES) })}</Text>
            <Text>
              {t(item.specificUnit ? 'RESOURCES.RATE_PER_EUR' : 'RESOURCES.RATE', {
                rate: (item.taxRate || 0).toFixed(UTB_REPORT_DECIMAL_PLACES),
                unit: item.specificUnit || 'N/A',
              })}
            </Text>
          </Box>
        </div>
      ))}

      <Divider />

      <Box p="xs">
        <Grid>
          <Grid.Col span={3}>
            <Text>{t('RESOURCES.SEQUENCE', { sequence: declaration.sequence })}</Text>
          </Grid.Col>
          <Grid.Col span={6} />
          <Grid.Col span={3}>{t('RESOURCES.DUE')}</Grid.Col>
        </Grid>
        {declaration.calculationResultsItems.map((item, itemIdx) => (
          <Grid key={itemIdx}>
            <Grid.Col span={3} />
            <Grid.Col span={3}>
              <Text>
                {item.taxType} {t(item.taxType === 'B00' ? 'RESOURCES.VAT' : 'RESOURCES.IMPORT_DUTIES')}
              </Text>
            </Grid.Col>
            <Grid.Col span={3} />
            <Grid.Col span={3}>
              <Text>€ {(item.payableTaxAmount || 0).toFixed(UTB_REPORT_DECIMAL_PLACES)}</Text>
            </Grid.Col>
          </Grid>
        ))}
        <Grid>
          <Grid.Col span={3} />
          <Grid.Col span={6} />
          <Grid.Col span={3}>
            <Divider my="xs" />
            <Text>€ {(sumBy(declaration.calculationResultsItems, (item) => item.payableTaxAmount || 0) || 0).toFixed(UTB_REPORT_DECIMAL_PLACES)}</Text>
          </Grid.Col>
        </Grid>
      </Box>
    </Paper>
  );
};
